/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-04-27 10:37:20
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-08-20 11:05:11
 * @Notes:
 */

import { imagemanager } from "./imagemanager";
import { coupons } from "./coupons";

export interface RootModel {
  imagemanager: typeof imagemanager;
  coupons: typeof coupons;
  // global: any;
}

export const models: RootModel = { imagemanager, coupons };
